<template>
  <b-row style="height: 80vh; width: 80vw;">
    <b-col cols="12">
      <b-row>
        <b-col cols="6">
          <div class="d-flex justify-content-between align-items-center h-100 mb-2">
            <b-form-input
              v-model="searchQuery"
              placeholder="Search by Name Engineer..."
              class="w-100 h-50"
            />
          </div>

        </b-col>
        <b-col
          cols="6"
          class="d-flex justify-content-between"
        >
          <b-row class="w-100">
            <b-col cols="8">
              <div class="py-1 ">
                <label style="font-weight: bold; font-size: large; text-decoration: underline; color: #009df7;">Filter by Sources :</label>
              </div>
              <div class="mb-2 d-flex justify-content-between">
                <b-form-checkbox
                  v-model="selectedSources"
                  value="jeem1"
                >
                  Jeem1
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="selectedSources"
                  value="saber"
                >
                  Saber
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="selectedSources"
                  value="sfda"
                >
                  Sfda
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="selectedSources"
                  value="moiat"
                >
                  Moiat
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="selectedSources"
                  value="sls"
                >
                  Sls
                </b-form-checkbox>
              </div>
            </b-col>
            <b-col cols="4">
              <div class="py-1 ">
                <label style="font-weight: bold; font-size: large; text-decoration: underline; color: #009df7;">Filter by Late Requests:</label>
              </div>
              <div class="mb-2 d-flex justify-content-center">
                <b-form-checkbox
                  v-model="filterLateRequests"
                >
                  Late Requests
                </b-form-checkbox>
              </div>
            </b-col>
          </b-row>
        </b-col>

      </b-row>

      <b-table
        v-if="filteredItems.length"
        class="table-container"
        sticky-header
        :items="filteredItems"
        style="min-height: 68vh; width: 100%;"
        striped
      >
        <template #head(index)>
          <span>#</span>
        </template>
        <template #cell(index)="data">
          {{ data.index + 1 }} <!-- Keeps the human-readable index -->
        </template>

        <template #head(Load)>
          <div class="d-flex align-items-center">
            Load
            <b-button
              variant="link"
              class="p-0 ml-1"
              :disabled="isDesc"
              style="color: white;"
              @click="setSortOrder(true)"
            >
              ▲
            </b-button>
            <b-button
              variant="link"
              class="p-0"
              style="color: white;"
              :disabled="!isDesc"
              @click="setSortOrder(false)"
            >
              ▼
            </b-button>
          </div>
        </template>

        <template #cell(Sources)="data">
          <div class="d-flex align-content-center justify-content-center">
            <div
              v-for="(value, key) in data.item.Sources"
              :key="key"
              class="mx-2"
            >
              <b-button
                variant="outline-primary"
                size="sm"
                style="width: fit-content; height: 5vh; text-align: center; margin: 5px 0px;"
                @click="showSourceData( data.item['Name Engineer'] ,key, value )"
              >
                {{ key }}
              </b-button>
            </div>
          </div>
        </template>

        <template #cell(Load)="data">
          {{ data.item.Load }}
        </template>
      </b-table>

      <div
        v-else
        class="text-center mt-3"
      >
        <h3>This engineer does not have Analysis</h3>
      </div>
    </b-col>

    <b-modal
      v-model="isModalVisible"
      :title="sourceData.name"
      hide-footer
      scrollable
    >
      <ChartTable
        :colors1="selectedColors1"
        :colors2="selectedColors2"
        :source="`${sourceData.source}`"
        :requests-analysis="sourceData.data"
      />
    </b-modal>
  </b-row>
</template>

<script>
import ChartTable from '@/components/analysis-table/ChartTable.vue'
import { getColorArray, colors1, colors2 } from '@/components/analysis-table/colorUtils'

export default {
  components: {
    ChartTable,
  },
  props: {
    userAnalysisData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isModalVisible: false,
      sourceData: '',
      isDesc: true, // Default sorting to high-to-low
      searchQuery: '', // Search query for filtering
      selectedSources: [], // Array to hold selected sources
      filterLateRequests: false,
      items: this.userAnalysisData.map(data => ({
        index: '',
        'Name Engineer': data.engineer_name || '',
        Load: data.total_load || '',
        Sources: data.sources || {},
      })),
      colors1,
      colors2,
    }
  },
  computed: {
    filteredItems() {
      // Filter items by searchQuery
      let filtered = this.items.filter(item => item['Name Engineer'].toLowerCase().includes(this.searchQuery.toLowerCase()))

      // Further filter by selectedSources
      if (this.selectedSources.length > 0) {
        filtered = filtered.filter(item => this.selectedSources.some(source => item.Sources[source]))
      }

      if (this.filterLateRequests) {
        filtered = filtered.filter(item => Object.values(item.Sources).some(source => source.late_requests > 0))
      }
      // Sort the filtered items
      return filtered.sort((a, b) => (this.isDesc ? b.Load - a.Load : a.Load - b.Load))
    },
    selectedColors1() {
      return getColorArray(this.colors1, this.sourceData.source)
    },
    selectedColors2() {
      return getColorArray(this.colors2, this.sourceData.source)
    },
  },

  methods: {
    showSourceData(name, key, value) {
      this.sourceData = {
        name,
        source: key,
        data: value,
      }
      this.isModalVisible = true
    },
    setSortOrder(descending) {
      this.isDesc = descending
    },
  },
}
</script>

<style lang="scss">
.table-container::-webkit-scrollbar {
  width: 8px;
  height: 6px;
}

.table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.table-container::-webkit-scrollbar-thumb {
  background: #009df7;
  border-radius: 0px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: #009df7;
}
.table-container  {
  box-shadow: 0 0px 3px 0 rgba(0 ,0 ,0 ,0.9);
  background-color: white !important;
  border: none !important;
table{
  thead {
    tr th {
      background-color: #009df7 !important ;
      padding-top: 1.5rem !important;
      padding-bottom: 1.5rem !important;
      color: white !important;
    }

  }
}
}
</style>
